import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';
import { sumUnits } from './progress';

// Makes `task` a subtask of `target`, then sets the target's stored units to the sum of
// its subtasks (as the units card does when opened), so its row is right straight away.
// A target that had no subtasks gives up its own units, like adding a first subtask does.
export async function nestTask(task, target) {
  // Read the target's subtasks before the move; a scan right after it may not see it yet.
  const existing = await API.graphql(graphqlOperation(queries.listTasks, {filter: {parentTaskId: {eq: target.id}}, limit: 999999999}));
  await API.graphql(graphqlOperation(mutations.updateTask, {input: {id: task.id, parentTaskId: target.id}}));

  const children = existing.data.listTasks.items.filter(t => t.id !== task.id).concat([task]);
  const totals = sumUnits(children);
  target.pomodoros = String(totals.done);
  target.estimatedPomodoro = totals.estimate;
  await API.graphql(graphqlOperation(mutations.updateTask, {input: {id: target.id, pomodoros: target.pomodoros, estimatedPomodoro: target.estimatedPomodoro}}));
}
